import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import JuridicoLayout from './JuridicoLayout';
import JuridicoOficiosPage from './JuridicoOficiosPage';
import JuridicoOficioFormPage from './JuridicoOficioFormPage';
import JuridicoOficioDetalhePage from './JuridicoOficioDetalhePage';
import JuridicoDashboardPage from './JuridicoDashboardPage';

/** Rotas do Jurídico — isolado do shell de Contratos (padrão ARCA / Safety Huddle). */
export default function JuridicoModule() {
  return (
    <Routes>
      <Route path="/juridico" element={<JuridicoLayout />}>
        <Route index element={<Navigate to="/juridico/dashboard" replace />} />
        <Route path="dashboard" element={<JuridicoDashboardPage />} />
        <Route path="oficios" element={<JuridicoOficiosPage />} />
        <Route path="oficios/novo" element={<JuridicoOficioFormPage />} />
        <Route path="oficios/:id/editar" element={<JuridicoOficioFormPage />} />
        <Route path="oficios/:id" element={<JuridicoOficioDetalhePage />} />
        <Route path="*" element={<Navigate to="/juridico/dashboard" replace />} />
      </Route>
    </Routes>
  );
}
